import React, { Component } from 'react'
import { Button, Col, Form, Input, Menu, Row, List, Spin, Tabs, Upload, Icon, Checkbox } from 'antd';
import { connect } from 'react-redux';
import { ENV } from '../utils/http'
import { getHeaders } from '../utils/http';

class SbtUploadComponent extends Component {

  state = {
    baseDbType: '',
    sbtPlus: false,
    publish: false,
    errorMessages: []
  }

  changeBaseDbType(newDbType) {
    this.setState({
      baseDbType: newDbType
    });
  }

  toggleSbtPlus(checked) {
    this.setState({
      sbtPlus: checked
    });
  }

  togglePublish(checked) {
    this.setState({
      publish: checked
    });
  }

  render() {

    const self = this;

    const uploadProps = {
      accept: 'application/pdf',
      action: `${ENV.url}/admin/lawreports/upload?baseDbType=${this.state.baseDbType}&sbtPlus=${this.state.sbtPlus}&publish=${this.state.publish}`,
      className: 'upload-list-inline',
      onPreview(file) {
        window.open(file.url || file.originFileObj.url, '_blank');
      },
      onChange(info) {

        if (info.file.status === 'done') {

          if (info.file.response.id === -1) {
            self.setState({
              errorMessages: [{ name: info.file.name, message: info.file.response.message }].concat(self.state.errorMessages)
            })
          }

          info.file.originFileObj.uid = info.file.response.id;
          info.file.url = `/rattsfall/${info.file.response.id}`;
          info.file.originFileObj.url = `/rattsfall/${info.file.response.id}`;
        }
      },
      defaultFileList: []
    };

    console.dir(this.state.errorMessages);

    return (
      <div>

        <div style={{ width: 800 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col span={8}>Databaser för okommenterad pdf</Col>
            <Col span={16} >
              <Input onBlur={(e) => this.changeBaseDbType(e.target.value)} />
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col span={8}>Rättsfall +</Col>
            <Col span={16} >
              <Checkbox checked={this.state.sbtPlus} onChange={(e) => this.toggleSbtPlus(e.target.checked)}></Checkbox>
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col span={8}>Publicera direkt</Col>
            <Col span={16} >
              <Checkbox checked={this.state.publish} onChange={(e) => this.togglePublish(e.target.checked)}></Checkbox>
            </Col>
          </Row>
        </div>

        <Upload multiple={true} {...uploadProps}>
          <Button><Icon type="upload" /> Ladda upp</Button>
        </Upload>

        {this.state.errorMessages.length > 0 && <div style={{ marginTop: 20 }}>
          <h2>Misslyckade filer</h2>
          <List
            itemLayout="horizontal"
            dataSource={this.state.errorMessages}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={<span style={{color: '#d22'}}>{item.name}</span>}
                  description={item.message}
                />
              </List.Item>
            )}
          />
        </div>}

        {this.state.errorMessages.length === 0 &&
          <div style={{ whiteSpace: 'pre-line', width: 800, marginTop: 50 }}>
            <h3>Filnamn måste döpas på följande sätt</h3>
            Exempel på filnamn för Mark- och miljödomstol t e x <b>Q2102366tum20220315M.</b>
            <br /><br />
            Där <b>Q2102366</b> är våra nuvarande filnamn, som är baserade på domens mål nr
            Och <b>tum</b> är en förkortning för "Mark- och miljödomstolen i Umeå", andra förkortningar ska används för andra miljödomstolar:
            <br /><br />
            <b>20220315</b> står för domens beslutsdatum<br />
            <b>M</b> är en del av målnumret, andra domar skulle ha andra bokstäver, "F" eller "P"<br />
            Mål/Diarienr skulle i det här fallet fyllas i med "2021-M 2366"<br />
          </div>
        }

      </div>
    )
  }
}

const mapStateToProps = (state) => ({

});

export default connect(mapStateToProps)(SbtUploadComponent);



// WEBPACK FOOTER //
// ./src/sbt/sbtUploadComponent.js